import { dataVideo } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideo = /*#__PURE__*/createIcon(dataVideo)
export default IconVideo
